module.exports = __webpack_public_path__ + "static/media/liveroom-setting-entry.3d0e4f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-entry.png
// module id = 1971
// module chunks = 6